<!-- WIDGET ASISTENTE IA -->
<div class="fixed bottom-6 right-6 z-50 flex flex-col items-end">
  
  <!-- Ventana del Chat -->
  <div *ngIf="isChatOpen" 
       class="bg-white w-80 sm:w-96 rounded-2xl shadow-2xl border border-slate-200 mb-4 flex flex-col overflow-hidden transition-all transform origin-bottom-right"
       style="height: 450px;">
    <!-- Header Chat -->
    <div class="bg-blue-800 text-white p-4 flex justify-between items-center flex-shrink-0">
      <div class="flex items-center">
        <div class="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mr-3">
          <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
        </div>
        <div>
          <h4 class="font-bold text-sm mb-0">Asistente Virtual PMM</h4>
          <p class="text-xs text-blue-200 mb-0"></p>
        </div>
      </div>
      <button (click)="toggleChat()" aria-label="Cerrar chat" class="text-white hover:text-slate-200 bg-transparent border-0 cursor-pointer">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
      </button>
    </div>

    <!-- Cuerpo Mensajes -->
    <div #chatMessagesContainer class="flex-1 p-4 overflow-y-auto bg-slate-50 flex flex-col space-y-3">
      <div *ngIf="chatMessages.length === 0" class="text-center text-sm text-slate-500 mt-4">
        👋 ¡Hola! Soy tu asistente virtual de PMM.<br><br>
        Puedo ayudarte con cotizaciones, rastreo, facturación, cobertura, compra de guías, horarios y más.
      </div>

      <div *ngIf="chatMessages.length === 0" class="quick-actions" aria-label="Accesos rápidos">
        <button
          type="button"
          *ngFor="let action of quickActions"
          class="quick-action-btn"
          (click)="onQuickAction(action)">
          {{ action.label }}
        </button>
      </div>
      
      <div *ngFor="let msg of chatMessages" 
           class="flex w-full"
           [class.justify-end]="msg.role === 'user'">
        <div class="max-w-[80%] rounded-xl p-3 text-sm chat-message-text"
             [ngClass]="{
               'bg-blue-600 text-white': msg.role === 'user',
               'bg-slate-200 text-slate-800': msg.role === 'bot'
             }"
             [innerHTML]="linkifyText(msg.text)">
        </div>
      </div>

      <div *ngIf="isChatLoading" class="flex w-full">
        <div class="bg-slate-200 text-slate-800 rounded-xl p-3 text-sm flex space-x-1" aria-label="Escribiendo respuesta...">
          <div class="w-2 h-2 bg-slate-400 rounded-full animate-bounce"></div>
          <div class="w-2 h-2 bg-slate-400 rounded-full animate-bounce" style="animation-delay: 0.1s"></div>
          <div class="w-2 h-2 bg-slate-400 rounded-full animate-bounce" style="animation-delay: 0.2s"></div>
        </div>
      </div>
    </div>

    <!-- Input Chat -->
    <div class="p-3 bg-white border-t border-slate-100 flex items-center flex-shrink-0">
      <input type="text" 
             [(ngModel)]="chatInput"
             (keyup.enter)="sendMessage()"
              placeholder="Escribe tu pregunta aquí..." 
             aria-label="Mensaje para el asistente"
             class="flex-1 bg-slate-100 rounded-full px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border-0">
      <button (click)="sendMessage()" 
              [disabled]="!chatInput.trim() || isChatLoading"
              aria-label="Enviar mensaje"
              class="ml-2 bg-blue-600 text-white p-2 rounded-full hover:bg-blue-700 disabled:opacity-50 border-0 cursor-pointer">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path></svg>
      </button>
    </div>
  </div>

  <!-- Botón Flotante Toggle -->
  <button (click)="toggleChat()" 
          aria-label="Abrir asistente virtual"
          class="bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-2xl transition-transform hover:scale-105 flex items-center justify-center border-0 cursor-pointer">
    <svg *ngIf="!isChatOpen" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path></svg>
    <svg *ngIf="isChatOpen" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
  </button>
</div>

